/* eslint-disable no-unreachable */
/* eslint-disable max-len */
/* eslint-disable no-console */
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import PhotoOutlinedIcon from '@mui/icons-material/PhotoOutlined';
import ReplayCircleFilledIcon from '@mui/icons-material/ReplayCircleFilled';
import { Box, CircularProgress, LinearProgress } from '@mui/material';
import { Storage } from 'aws-amplify';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import usePermanentDelete from '../../containers/MediaDrive/customHooks/usePermanentDelete';
import { creatFolder } from '../../containers/actions/media_actions';
import { LanguageContext } from '../../libs/Context';
import { formatBytes, objectUrlToFile, s3DeleteNew, sanitizeFileName } from '../../libs/HelperContent';
import { resetMediaKitData, setMediaKitData } from '../../redux/MediakitRedux';
import './styles.css';
import useUpdateStorage from '../../containers/LicenseSubscription/customHooks/useGetStorage';

const ProgressBar = (props) =>
{
	const { fileData, action, handleUploadStatus, resetAction } = props;
	const { cancelAll, deleteUploaded } = action;
	const parentId = new URL(window.location.href).pathname.split('/')[3] || '';
	const userData = useSelector((state: any) => state.mysession.session);
	const { language } = useContext(LanguageContext);
	const dispatch = useDispatch();
	const promiseRef = useRef<any>('');
	const deletePermanently = usePermanentDelete();
	const mediaKitData = useSelector((state: any) => state?.mymediakit?.mediaKitData);
	const mediaRef:any = useRef({ oldData: mediaKitData[fileData?.openedTab] });
	const setStorageData = useUpdateStorage();
	const loggingOut = useSelector((state:any) => state.mymediakit.loggingOut);

	mediaRef.current.parentId = parentId;
	useEffect(() =>
	{
		if (parentId === mediaRef?.current?.parentId)
		{
			mediaRef.current.oldData = mediaKitData[fileData?.openedTab];
		}
	}, [ mediaKitData ]);

	const isFolder = fileData?.type === 'folder';
	const [ fileInfo, setFileInfo ] = useState({
		name           : fileData?.name,
		type           : fileData?.type,
		size           : fileData?.size,
		percent        : 0,
		bytesUploaded  : 0,
		loading        : true,
		status         : 'inprogress',
		ownerCompanyId : fileData?.ownerCompanyId
	});

	const updateFileInfo = (data) =>
	{
		setFileInfo((prevFileInfo) => ({ ...prevFileInfo, ...data }));
	};

	const addMediaType = (media) =>
	{
		return media.map((item) =>
		{
			let mediaType = 1;

			switch (item?.type.split('/')[0])
			{
				case 'application':
				case 'text':
					mediaType = 2;
					break;
				case 'image':
					mediaType = 3;
					break;
				case 'audio':
					mediaType = 4;
					break;
				case 'video':
					mediaType = 5;
					break;
				default:
					break;
			}

			return { ...item, mediaType };
		});
	};

	const uploadMediaFiles = async (mediaFile, type) =>
	{
		const totalSize = fileData?.size;

		let fileSizeUptoLastUpload = 0;

		const progressCallback = (progress) =>
		{
			const percent = Math.round(((fileSizeUptoLastUpload + progress.loaded) / totalSize) * 100);

			if (percent > 0)
			{
				updateFileInfo({ percent, loading: false, bytesUploaded: fileSizeUptoLastUpload + progress.loaded });
			}

			if (progress.loaded === progress.total)
			{
				fileSizeUptoLastUpload += progress.total;
			}
		};

		const errorCallback = (err) =>
		{
			console.error('error**', err);
		};

		Storage.configure({
			bucket : process.env.REACT_APP_S3_BUCKET,
			region : process.env.REACT_APP_S3_BUCKET_REGION
		});

		const resultArray:any = [];

		for (const media of mediaFile)
		{
			const File = await objectUrlToFile(media?.objectUrl, media?.name);

			type = type !== '' ? type : 'public';

			const customPrefix = { public: `${fileData?.ownerCompanyId}/drive/` };

			const sanitizedKey = sanitizeFileName(`${new Date().valueOf()}_${File?.name.replace(' ', '_')}`);
			let result:any = Storage.put(sanitizedKey, File, { customPrefix, contentType: File.type, progressCallback, errorCallback });

			promiseRef.current = result;
			result = await result;

			mediaRef.current.key = result.key;
			resultArray.push({
				url   : `${process.env.REACT_APP_S3_BASE_URL}/${userData?.companyId}/drive/${result.key}`,
				type  : File.type,
				key   : `${userData?.companyId}/drive/${result.key}`,
				title : File.name,
				name  : File.name,
				size  : File.size,
				path  : `${userData?.companyId}/drive/`
			});
		}

		return resultArray;
	};

	const handleCancel = async () =>
	{
		if (fileInfo?.status !== 'completed')
		{
			setStorageData({ action: 'del', size: fileData?.size, ownerCompanyId: fileData?.ownerCompanyId });
			Storage.cancel(promiseRef.current, 'cancelled by user');
			updateFileInfo({ loading: false, status: 'cancelled' });
			handleUploadStatus('cancelled');
		}
	};

	const removeData = (idArray) =>
	{
		if (fileData?.parentId === mediaRef.current.parentId)
		{
			const newData = mediaRef?.current?.oldData?.filter((item) => !idArray.includes(item?.folderId));

			mediaRef.current.oldData = newData;
			dispatch(setMediaKitData({ [fileData?.openedTab]: mediaRef?.current?.oldData }));
		}
	};

	const handleSharedData = (newData) =>
	{
		if (fileData?.openedTab === 'sharedData')
		{
			Object.assign(newData, {
				createdUser : { name: userData?.firstName },
				shareAccess : fileData?.parentData?.shareAccess,
				sharedAt    : newData?.updatedAt
			});
		}
	};

	const handlePrevData = (newData:any) =>
	{
		let prevData:any = [];

		if (fileData?.hasOwnProperty('updateExist') && fileData?.updateExist)
		{
			prevData = mediaRef?.current?.oldData.map((item) =>
				(item?.name === fileData?.name
					? {
						...item,
						...newData,
						media     : fileData?.type === 'folder' ? {} : newData,
						updatedAt : new Date()
					}
					: item)
			);
		}
		else
		{
			prevData = [ newData, ...mediaRef?.current?.oldData ];
		}

		return prevData;
	};

	const setData = (data) =>
	{
		if (fileData?.parentId === mediaRef.current.parentId)
		{
			const newData = { ...data[0] };

			handleSharedData(newData);

			const prevData = handlePrevData(newData);

			mediaRef.current.oldData = [ ...prevData ];
			dispatch(setMediaKitData({ [fileData?.openedTab]: [ ...prevData ] }));
		}
	};

	const getQuery = () =>
	{
		return {
			uid     : userData?.userId,
			comid   : userData?.companyId,
			empRole : userData?.empRole,
			role    : userData?.role
		};
	};

	const getBody = (media) =>
	{
		const body:any = {
			type   : 1,
			parent : fileData?.parentId
		};

		if (fileData.hasOwnProperty('updateExist'))
		{
			if (fileData.updateExist)
			{
				body.updateExistData = [
					{
						folderId : fileData?.folderId,
						media    : media[0]
					}
				];
			}
		}
		else
		{
			body.newData = media;
		}

		return body;
	};

	const handleResponse = (res, media) =>
	{
		if (res.status)
		{
			if (!fileData?.updateExist)
			{
				mediaRef.current.idArray = res?.data.map((item) => item?.folderId);
			}
			updateFileInfo({ loading: false, status: 'completed' });
			handleUploadStatus('completed');
			setData(fileData?.updateExist ? media : res?.data);
		}
		else
		{
			toast.error(`${language?.folderNotUploaded}`, {
				position : toast.POSITION.TOP_RIGHT
			});
		}
	};

	const handleError = (err) =>
	{
		console.log('err', err);
		updateFileInfo({
			loading : false,
			status  : Storage.isCancelError(err) ? 'cancelled' : 'error'
		});
		handleUploadStatus(Storage.isCancelError(err) ? 'cancelled' : 'error');
	};

	const handleUploadFiles = (media) =>
	{
		const query = getQuery();
		const body = getBody(media);

		creatFolder(query, body)
			.then((res) => handleResponse(res, media))
			.catch((err) => handleError(err));
	};

	const getMediaType = (media) =>
	{
		switch (media?.type.split('/')[0])
		{
			case ('application'):
			case ('text'):
				return 2;
			case ('image'):
				return 3;
			case ('audio'):
				return 4;
			case ('video'):
				return 5;
			default:
				return 2;
		}
	};

	const handleUploadFolder = (media) =>
	{
		let body;
		let currentFile = [];
		const root = { name: '', mediaType: 1, media: {}, folders: [] };
		const query:any = { uid: userData?.userId, comid: userData?.companyId, empRole: userData?.empRole, role: userData?.role };

		if (fileData?.hasOwnProperty('updateExist') && fileData?.updateExist)
		{
			query.updateExist = fileData?.updateExist;
		}

		fileData?.fileList?.forEach(async (item:any, ind:number) =>
		{
			body = media[ind];

			currentFile = body;
			const mediaType = getMediaType(currentFile);
			const fullPath = item.webkitRelativePath;
			const pathElements = fullPath?.split('/');

			if (fileData?.hasOwnProperty('updateExist') && !fileData?.updateExist)
			{
				pathElements[0] = fileData?.name;
			}
			let currentFolder:any = root;

			for (const element of pathElements)
			{
				const existingFolder = currentFolder.folders.find((f) => f.name === element);

				if (existingFolder)
				{
					currentFolder = existingFolder;
				}
				else
				{
					const newFolder:any = { name: element, mediaType: 1, media: {}, folders: [] };

					currentFolder.folders.push(newFolder);
					currentFolder = newFolder;
				}
			}
			currentFolder.media = currentFile;
			currentFolder.mediaType = mediaType;
		});

		const apiBody = {
			parent : fileData?.parentId,
			type   : 0,
			folder : root.folders
		};

		creatFolder(query, apiBody)
			.then((res) =>
			{
				setData(res?.data);
				updateFileInfo({ loading: false, status: 'completed' });
				handleUploadStatus('completed');
			})
			.catch((err) =>
			{
				console.log('err', err);
				updateFileInfo({ loading: false, status: Storage.isCancelError(err) ? 'cancelled' : 'error' });
				handleUploadStatus(Storage.isCancelError(err) ? 'cancelled' : 'error');
			});
	};

	const startUpload = async () =>
	{
		try
		{
			const upload = await uploadMediaFiles(fileData?.type === 'folder' ? fileData?.fileList : [ fileData ], 'drive');

			if (upload)
			{
				updateFileInfo({ loading: true });
				const media = addMediaType(upload);

				isFolder ? handleUploadFolder(media) : handleUploadFiles(media);
			}
		}
		catch (err)
		{
			console.log('err**', err);
			updateFileInfo({ loading: false, status: Storage.isCancelError(err) ? 'cancelled' : 'error' });
			handleUploadStatus(Storage.isCancelError(err) ? 'cancelled' : 'error');
		}
	};

	const handleRetry = () =>
	{
		const tempFileInfo = {
			name           : fileData?.name,
			type           : fileData?.type,
			size           : fileData?.size,
			percent        : 0,
			bytesUploaded  : 0,
			loading        : true,
			status         : 'inprogress',
			ownerCompanyId : fileData?.ownerCompanyId
		};

		setStorageData({ action: 'add', size: fileData?.size, ownerCompanyId: fileData?.ownerCompanyId });
		setFileInfo(tempFileInfo);
		handleUploadStatus('inprogress');
		startUpload();
	};

	useEffect(() =>
	{
		startUpload();

		return () =>
		{
			const mediaFile = fileData?.type === 'folder' ? fileData?.fileList : [ fileData ];

			for (const media of mediaFile)
			{
				URL.revokeObjectURL(media?.objectUrl);
			}
		};
	}, []);

	const deleteUploadedData = async () =>
	{
		mediaRef.current?.key && s3DeleteNew(mediaRef.current.key, 'drive');

		if (mediaRef.current?.idArray)
		{
			await deletePermanently({ idArray: mediaRef.current.idArray, fromUpload: true });
			removeData(mediaRef.current.idArray);
		}
	};

	useEffect(() =>
	{
		(cancelAll || fileData?.length === 0) && handleCancel();
		if (deleteUploaded)
		{
			deleteUploadedData();
		}
		resetAction();
	}, [ cancelAll, fileData, deleteUploaded ]);

	const handleRemoveSize = (event) =>
	{
		if (fileInfo?.status === 'inprogress')
		{
			// Show alert for ongoing uploads
			const message = language?.uploadInProgress || 'You have files uploading. Are you sure you want to leave?';

			event.preventDefault();
			event.returnValue = message;

			// Handle storage cleanup
			const prevUnfinishedUploads = JSON.parse(localStorage.getItem('unfinishedUploads') ?? '{}');
			const updatedUnfinishedUpload = { ...prevUnfinishedUploads, [fileData?.ownerCompanyId]: (prevUnfinishedUploads[fileData?.ownerCompanyId] || 0) + fileData?.size };

			localStorage.setItem('unfinishedUploads', JSON.stringify(updatedUnfinishedUpload));

			return message;
		}
	};

	useEffect(() =>
	{
		window.addEventListener('beforeunload', handleRemoveSize);

		if (loggingOut)
		{
			handleCancel();
			dispatch(resetMediaKitData());
		}

		return () =>
		{
			window.removeEventListener('beforeunload', handleRemoveSize);
		};
	}, [ loggingOut ]);

	const errorStatus = ([ 'cancelled', 'error' ].includes(fileInfo?.status));
	const checkIcon = fileInfo?.type?.split('/')[0] === 'image' ? <PhotoOutlinedIcon color='success' /> : <InsertDriveFileIcon color='primary'/>;

	return (
		<div key={fileInfo?.name} className='flexRow alignCntr justifyCntr whiteBg'>
			<div className='progressBar pdngHSM'>
				<div className='flexRow alignCntr pdngHXS'>
					<div className='flexAutoRow'>
						{isFolder ? <FolderCopyIcon color='primary' /> : checkIcon}

					</div>
					<div className='flexMinWidthCol pdngXS'>
						<div className='flexRow pdngVXS'>
							<div className='flexMinWidthRow'>
								<span className='subHeadingXS ellipsisTxt'>
									{fileInfo?.name?.length >= 20 ? `${fileInfo?.name.slice(0, 20)}...` : fileInfo?.name}
									<span className='lightTxt'>
										{` - ${formatBytes(fileInfo?.bytesUploaded)} (${fileInfo.percent}%)`}
									</span>
								</span>
							</div>
							<div className='flexAutoRow alignCntr pdngLSM subHeadingXS'>
								{errorStatus &&
								<div className='flexInline pdngRXXS'>
									<span className='textDanger'>{fileInfo?.status === 'cancelled' ? 'Cancelled' : 'error'}</span>
								</div>
								}
								{
									fileInfo?.loading
										? <CircularProgress size={20} disableShrink />
										: <>
											{(fileInfo?.status === 'inprogress') && <CancelIcon onClick={handleCancel} className=' pointer'/>}
											{(fileInfo?.status === 'completed') && <CheckCircleIcon color='success' />}
											{([ 'cancelled', 'error' ].includes(fileInfo?.status)) && <ReplayCircleFilledIcon className='lightTxt pointer' onClick={handleRetry} color='success' />}
										</>
								}
							</div>
						</div>
						<div className='flexRow pdngVXXS'>
							<Box sx={{ width: 'var(--percent100)', mr: 1 }}>
								{errorStatus
									? <LinearProgress color='error' variant='determinate' value={100}/>
									: <LinearProgress variant='determinate' value={fileInfo?.percent} color='success'/>}
							</Box>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProgressBar;